import LocalizationStorage from '%app/js/common/services/localizationStorage';
import { createBrowserHistory } from 'history';

const history = createBrowserHistory({
    basename: `/${LocalizationStorage.getLocalizationContext()}`,
});

export default history;
